import { createSelector } from 'reselect';

const root = state => state.lessonStartForm;

export const getFormData = createSelector(root, state => state.formData);
export const getErrors = createSelector(root, state => state.errors);
export const getNonFieldError = createSelector(root, state => state.nonFieldError);



// WEBPACK FOOTER //
// ./src/incab/common/LessonStartForm/selectors.js